// extracted by mini-css-extract-plugin
export default {"container":"space_container__cwOCm","stars":"space_stars__vcVr1","animStar":"space_animStar__PzM8i","stars2":"space_stars2__oRwAn","stars3":"space_stars3__mmp-j"};